angular.module('mtic')
.service('PanelFactory', function (
  $log,
  TeacherDataService,
  userAccount,
  language,
  EventManager,
  C4_ASSET_URL,
  GR78_ASSET_URL,
  $timeout,
  MapStateService,
  PlatformService,
  $rootScope
) {
  var eventManager = new EventManager('panelFactory');
  var tab_options = null;
  var getTagsForClass = function(classId){
     var tags = TeacherDataService.getClassPanelConfig(classId);
    //  $log.log('[[tags]]', tags)
     return tags;
  }

  var prefixMatch = function(str, match){
    return (str.substr(0, match.length) === match)
  }

  var defaultPriorityOfViews = {
    'dashboard': 1,
    'studentsAddRemove': 2,
    'agenda': 3,
    'reports': 4,
    'workspace': 5,
    'modules': 6,
    'items': 7,
    'class-leaderboard': 8,
  }

  var timed_out = false;
  function reset_timer(){
    timed_out = true;
    $timeout(function(){
      timed_out = false;
    }, 500)
  }

  eventManager.listen('request:tab:options', function(){
    eventManager.broadcast('response:tab:options', tab_options);
  })


  return {

    getItemImage: function(item){
      var itemsListed = {};
      if(item.display && item.display.images){
        var arr = [];
        item.display.images.forEach(function(imgNum){
          var imgStr = ''+imgNum;
          if (imgStr.length === 1){ imgStr = '000'+imgStr; }
          if (imgStr.length === 2){ imgStr = '00'+imgStr; }
          if (imgStr.length === 3){ imgStr = '0'+imgStr; }
          imgStr = 's'+imgStr;
          if (!itemsListed[imgStr]){
            itemsListed[imgStr] = true;
            arr.push(imgStr);
          }
        })
        // $log.log('RETURNING : ', item.display.images)
        return arr;
      }
    },

    getModuleIconAssetUrl: function(filename, metaMod, parentId){
      if(!filename) {return ''}
      var ext = '.png';
      var C3_ASSET_URL = 'assets/images/c3-meta/';
      var OCMT_ASSET_URL = 'assets/images/gr78/';
      
      // OCMT
      if(prefixMatch(filename, 'ocmt_hse')){
        return OCMT_ASSET_URL + filename + ext;
      }
      else{
        if (prefixMatch(filename, 'mtic_c3') || (metaMod && metaMod[0].slug === "mtic_c3_m_meta")){
          return C3_ASSET_URL+filename+ext;
        }
        if (prefixMatch(filename, 'mtic_gr78') || prefixMatch(filename, 'mtic_gr910')){
          return GR78_ASSET_URL + filename + ext;
        }
        if (prefixMatch(filename, 'c4') || prefixMatch(filename, 'run_like_math')){
          return C4_ASSET_URL + filename + ext;
        }
      }
    },

    setupScopedMenuForStudentPanel: function(scope, classId){
//       var spliceModules = false;
//       // var is_ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
//       // var is_android = navigator.userAgent.match(/Android/i);
//       // var tabletCheck = is_ios || is_android;
//       TeacherDataService.getModuleMap(classId).then( (data)=>{
//         if(data.Modules[0].module_id === 28){
// //          console.log('cycle 4 module panel, remove!')
//           spliceModules = true;
//         }

        var PanelFactory = this;
        getTagsForClass(classId).then(function(panelData){
          // Temporary function to add Share-my-class tab to teacher dashboard, until it exists on firebase or somewhere
          var shareClassExists = false;
          var agendaPanelExists = false;
          var userData = userAccount.getData();
          var i = 0;

          var found = false;
          panelData.forEach(function(tag){
            if(tag.id === 'agenda'){
              found = true;
            }
          })
          if(!found){
            panelData.push({id: 'agenda', name: 'Agenda'})
          }
          //panelData.push({id: 'class-leaderboard', name: 'Leaderboard'})


          panelData.forEach(function(panel){
            i++
          });


          var panelDataPrioritized = [];
          var panelDataNonPrioritized = [];
          panelData.forEach(function(panelTab){
            if(defaultPriorityOfViews[panelTab.id]){
              panelDataPrioritized[defaultPriorityOfViews[panelTab.id]] = panelTab;
            }else{
              panelDataNonPrioritized.push(panelTab);
            }
          })
          $log.debug('[[PanelFactory]] Reading > /class/`'+classId+'`/panelData/`',panelData,'`')

          PanelFactory.setupOrUpdateScopedMenu(scope, panelDataPrioritized.concat(panelDataNonPrioritized))
        })
      // })
    },
    setupOrUpdateScopedMenu: function(scope, options){
//      console.log('panel setupOrUpdateScopedMenu', options)
      if(scope.nav){
        var selection = scope.nav.selection;
        this.setupScopedMenu(scope, options);
        if(scope.nav.isValid(selection)){
          scope.nav.selection = selection;
        }
      }else{
        this.setupScopedMenu(scope, options)
      }
    },
    setupScopedMenu: function(scope, options){
      // $log.log('panel setupScopedMenu', options)
      options = options.filter(function(opt){
        return optionsBrandingFilter(opt) && !opt.disable
      });
      if (!$rootScope.isOCMT){
        var leaderBoard_i = -1;
        var documents_i = -1;
        options.forEach( function(opt, i ){
          if (opt.id === 'docs'){
            documents_i = i;
          }
          if (opt.id === 'class-leaderboard'){
            leaderBoard_i = i;
          }
        })
        if (leaderBoard_i === -1){
          var injection_i = (documents_i === -1) ? (options.length-1) : documents_i;
          options.splice(injection_i, 0, {id: 'class-leaderboard'});
        }
      }
      function optionsBrandingFilter(option){
        var mticOnlyOptions = ['docs', 'share-class', 'class-leaderboard'];
        var include = true;
        if($rootScope.isOCMT && mticOnlyOptions.indexOf(option.id) !== -1){
          include = false;
        }
        return include;
      }
      // options.splice(1,0, {"id":"studentsAddRemove","name":"Add/Remove"}) // testing
      var optionsWhitelist = options.map(function(opt) {return opt.id});
      // $log.debug('[[PanelFactory]] making scopedMenu from ', options)
      var nav = scope.nav = {

        selection: '',
        isValid: function(id){
          return options.filter(function(opt){ return opt.id === id}).length > 0
        },

        setSelection: function(optionSlug, agenda_resolve, options){
          tab_options = options;
          // On phones, change selection only after sidebar width transition is over
          if(PlatformService.isPhonePortrait() && window.location.href.indexOf('open_item_link') === -1){
            // Register transitionend listener
            scope.els = scope.els || {};
            scope.els.sidebar = scope.els.sidebar || document.querySelector('.menu.side-menu');
            scope.els.sidebar.removeEventListener('transitionend', mOnSidebarTransitionEnd);
            scope.els.sidebar.addEventListener('transitionend', mOnSidebarTransitionEnd);
            $rootScope.sidebarExpanded = false;
            handleSelection()
          }
          else{ // otherwise change selection immediately
            handleSelection()
          }

          // ontransitionend handler
          function mOnSidebarTransitionEnd(e){
            if(e.srcElement === scope.els.sidebar && e.propertyName === 'width'){
              scope.els.sidebar.removeEventListener('transitionend', mOnSidebarTransitionEnd);
              handleSelection()
            }
          }

          function handleSelection(){
            if(optionSlug === nav.selection){
              return;
            }

            if (optionsWhitelist && ( _.indexOf(optionsWhitelist, optionSlug) === -1) ){
              $log.error('Nav option selected is not on whitelist'); // dont break
            }

            if(nav.selection === 'agenda' && !agenda_resolve){
              eventManager.broadcast('request_agenda_change', optionSlug);
              return;
            }
            if(timed_out){
              return;
            }
            if(nav.selection === 'modules'){
              eventManager.broadcast('module:close:resource');
            }
            reset_timer();
            language.resetAvilableOptions();
            if(optionSlug === nav.selection){
              scope.nav.resetSelection();
            }else{
              nav.selection = optionSlug;
            }

            var slugText = optionSlug;
            if (optionSlug === "workspace") {
              slugText = "activity_log";
            }

            MapStateService.reset();
            eventManager.broadcast('teacher:change:tab', slugText);
          }

        },

        getSelection: function(){
          return nav.selection;
        },

        isSelection: function(optionSlug){
          return (nav.selection === optionSlug);
        },
        getAllSelections: function(){
          return options;
        },
        resetSelection: function(){
          var temp = nav.selection;
          nav.selection = '';
          $timeout(function(){
            nav.selection = temp;
          }, 200)
        }
      }

      if (optionsWhitelist){
        nav.selection = optionsWhitelist[0];
      }

    }
  }

});
